import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedProductImport, selectProductImportState, setAction } from "../redux/slices/ProductImportSlice"
import { ProductsImportAPI } from "../apis/ProductsImportAPI"
import { productImport } from "../types/slices/productImportType"

export const useProductImportStore = () => {

    const dispatch = useDispatch()
    const { products, productSelected, status, action } = useSelector(selectProductImportState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getImportedProducts = async (data:{}) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsImportAPI.getImportedProducts(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const ValidateUserImport = async () => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsImportAPI.ValidateUserImport()
            console.log(response)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { message } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return message;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editImportedProduct = async (idproduct: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsImportAPI.editImportedProduct(idproduct, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const saveImportedProduct = async (idproduct: number) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsImportAPI.saveImportedProduct(idproduct)
            console.log(response)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const saveImportedProductMassive = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsImportAPI.saveImportedProductMassive(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteImportedProduct = async (idproduct: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsImportAPI.deleteImportedProduct(idproduct)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedImported = (product: productImport) => {
        try {
            dispatch(onSetSelectedProductImport(product))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionImported = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        products,
        productSelected,
        status,
        action,
        //actions
        getImportedProducts,
        ValidateUserImport,
        editImportedProduct,
        saveImportedProduct,
        saveImportedProductMassive,
        deleteImportedProduct,
        setSelectedImported,
        setActionImported,
    }
}